export interface CustomActions {
  id: number;
  name: string | null;
  description: string | null;
}

export class CustomAction implements CustomActions {
  id: number;
  name: string | null;
  description: string | null;

  constructor() {
    this.id = 0;
    this.name = '';
    this.description = '';
  }
}

export interface CustomActionsMapping {
  id: number;
  customActionId: number;
  requestStatusId: number;
  sequence: number;
}

export class CustomActionsMapping implements CustomActionsMapping {
  id: number;
  customActionId: number;
  requestStatusId: number;
  sequence: number;

  constructor() {
    this.id = 0;
    this.customActionId = 0;
    this.requestStatusId = 0;
    this.sequence = 0;
  }
}
